// src/components/SearchPage.js

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Book from "./Book"; // Imports adjusted for relative paths

const SearchPage = ({ query, setQuery, mergedBooks, updateBookShelf }) => {
    return (
        <div className="search-books">
            <div className="search-books-bar">
                {/* Link back to Main Page */}
                <Link to="/">
                    <button className="close-search">Close</button>
                </Link>
                <div className="search-books-input-wrapper">
                    {/* Search Input */}
                    <input
                        type="text"
                        placeholder="Search by title or author"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                </div>
            </div>
            <div className="search-books-results">
                {/* Display a message if there are no search results, handling 1st Search Req (b, c, e) */}
                {query && mergedBooks.length === 0 ? (
                    <div className="search-error">
                        No results found for "{query}". Please use a valid search term.
                    </div>
                ) : (
                    <ol className="books-grid">
                        {/* Displaying results and shelf control (2nd Search Req) */}
                        {mergedBooks.map((b) => (
                            <li key={b.id}>
                                <Book book={b} changeBookShelf={updateBookShelf} />
                            </li>
                        ))}
                    </ol>
                )}
            </div>
        </div>
    );
};

SearchPage.propTypes = {
    query: PropTypes.string.isRequired,
    setQuery: PropTypes.func.isRequired,
    mergedBooks: PropTypes.array.isRequired,
    updateBookShelf: PropTypes.func.isRequired,
};

export default SearchPage;